import { useState } from "react";
import { Modal } from "../ui-bits";
import { Plus, Trash2 } from "lucide-react";

export function DeliveryConfirm({ p, pieces, busy, onClose, onConfirm }) {
  const init = p.breakdown?.length ? p.breakdown.map(b => ({ size: b.size || "", color: b.color || "", qty: b.qty })) : [{ size: "", color: "", qty: Number(pieces) || p.pieces }];
  const [rows, setRows] = useState(init);
  const set = (i, patch) => setRows(rs => rs.map((r, j) => (j === i ? { ...r, ...patch } : r)));
  const total = rows.reduce((s, r) => s + (Number(r.qty) || 0), 0);
  return (
    <Modal open onClose={onClose} title={`Carica a magazzino · ${p.number}`}>
      <div data-testid="delivery-confirm">
        <p className="text-sm opacity-70 mb-4">Conferma i capi consegnati: verranno caricati nel magazzino prodotti finiti per taglia e colore.</p>
        <table className="tbl w-full text-sm [&_td]:!px-2 [&_th]:!px-2">
          <thead><tr><th>Taglia</th><th>Colore</th><th className="text-right">Pezzi</th><th/></tr></thead>
          <tbody>{rows.map((r, i) => (
            <tr key={i} data-testid={`delivery-row-${i}`}>
              <td><input className="input-dark !py-1" value={r.size} onChange={e => set(i, { size: e.target.value })} data-testid={`delivery-size-${i}`}/></td>
              <td><input className="input-dark !py-1" value={r.color} onChange={e => set(i, { color: e.target.value })} data-testid={`delivery-color-${i}`}/></td>
              <td><input type="number" min="0" className="input-dark !py-1 text-right" value={r.qty} onChange={e => set(i, { qty: e.target.value })} data-testid={`delivery-qty-${i}`}/></td>
              <td><button onClick={() => setRows(rs => rs.filter((_, j) => j !== i))} className="opacity-60 hover:opacity-100" data-testid={`delivery-remove-${i}`}><Trash2 size={14}/></button></td>
            </tr>))}</tbody>
        </table>
        <button onClick={() => setRows([...rows, { size: "", color: "", qty: 0 }])} className="text-xs mt-3 inline-flex items-center gap-1 hover:underline" data-testid="delivery-add-row"><Plus size={12}/> Aggiungi riga</button>
        <div className="flex items-center justify-between mt-6">
          <span className="text-sm" data-testid="delivery-total">Totale: <b>{total}</b> pezzi</span>
          <button disabled={busy || total <= 0} onClick={() => onConfirm(rows.map(r => ({ ...r, qty: Number(r.qty) || 0 })))} className="btn-gold" data-testid="delivery-confirm-btn">
            {busy ? "Salvataggio…" : "Conferma e carica"}</button>
        </div>
      </div>
    </Modal>
  );
}
